if (!customElements.get("m-comparison")) {
  class MComparison extends HTMLElement {
    constructor() {
      super(),
        this.selectors = {
          panels: ".product-panel",
          compareSelect: "[data-compare-select]",
          itemCount: "[item-count]"
        },
        this._resizeHandler = this.syncHeight.bind(this);
      this._mediaHandler = () => this.debounce(this.syncHeight.bind(this), 50);
      this.init()
    }
    init() {
      this.domNodes = this.queryDomNodes(),
        this.setupEventListeners(),
        this.syncHeight();

    }
    queryDomNodes() {
      return Object.entries(this.selectors).reduce((acc, [key, selector]) => {
        acc[key] = this.querySelector(selector);
        return acc;
      }, {});
    }
    setupEventListeners() {
      this.setupToggleListener();
      this.setupTabListener();
      this.setupMediaListeners();
    }
    setupMediaListeners() {
      const events = ["matchMobile", "unmatchMobile", "matchTablet", "unmatchTablet"];
      events.forEach(eventName => {
        document.addEventListener(eventName, this._mediaHandler);
      });
    }
    setupTabListener() {
      const tabHeader = document.querySelector('.tab-header[data-block-type="comparison"]');
      if (tabHeader) {
        tabHeader.addEventListener('click', () => {
          this.debounce(this.syncHeight.bind(this), 300);
        });
      }
    }
    setupToggleListener() {
      const select = this.querySelector(this.selectors.compareSelect);
      if (select) {
        select.addEventListener("change", (event) => {
          this.togglePanels(event.target.value);
          this.debounce(this.syncHeight.bind(this), 300);
        });
      }
    }
    togglePanels(value) {
      this.querySelectorAll('[data-comparison-panel]').forEach(panel => {
        panel.classList.toggle("hidden", panel.dataset.comparisonPanel !== value);
      });
    }
    debounce(fn, delay) {
      clearTimeout(this._timeout);
      this._timeout = setTimeout(fn, delay);
    }
    syncHeight() {
      const elements = this.querySelectorAll('[item-count]');
      elements.forEach(el => el.style.height = 'auto');
      const heightGroups = {};
      elements.forEach(element => {
        const count = element.getAttribute('item-count');
        if (!heightGroups[count]) {
          heightGroups[count] = [];
        }
        heightGroups[count].push(element);
      });
      Object.values(heightGroups).forEach(group => {
        const maxHeight = Math.max(...group.map(el => el.offsetHeight));
        if (maxHeight > 0) {
          group.forEach(el => el.style.height = `${maxHeight}px`);
        }
      });
    }
    reinit() {
      this.debounce(this.syncHeight.bind(this), 50);
    }
    disconnectedCallback() {
      clearTimeout(this._timeout);
      const events = ["matchMobile", "unmatchMobile", "matchTablet", "unmatchTablet"];
      events.forEach(eventName => {
        document.removeEventListener(eventName, this._mediaHandler);
      });
    }
  }
  customElements.define("m-comparison", MComparison);
}